export const  Image = process.env.VUE_APP_IMAGE
export const  Server= process.env.VUE_APP_BASE_API

const BASE = '/api'

export const app ={
  login: BASE + '/login',
  logout:BASE + '/logout',
  getUserinfo: BASE + '/users',
}

export const article = {
}